/* @ngInject */
export default function dashPercentage() {
    return function (input) {
        if (input === undefined || input === null) {
            return '-';
        }

        return `${input}%`;
    };
}



// WEBPACK FOOTER //
// ./src/app/common/angular/filters/dashPercentage.filter.js